import { render, staticRenderFns } from "./bianyaqi.vue?vue&type=template&id=52ae3ad2&scoped=true&"
import script from "./bianyaqi.vue?vue&type=script&lang=js&"
export * from "./bianyaqi.vue?vue&type=script&lang=js&"
import style0 from "./bianyaqi.vue?vue&type=style&index=0&id=52ae3ad2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ae3ad2",
  null
  
)

export default component.exports